// extracted by mini-css-extract-plugin
module.exports = {"flex":"SearchBar_flex__3cnFm","input":"SearchBar_input__EUgGu"};